import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * One path param of the current route, reactive — read an id with this and not with
 * `useRoute().params[name]`, which is read once in setup and does not follow a navigation
 * between two ids of the same page.
 *
 * `undefined` while the route carries no such param, so a query fed from it has to stay
 * disabled until it is truthy.
 */
export function useRoutePathParam(name: string) {
  const route = useRoute()
  return computed(() => {
    return route.params[name] as string | undefined
  })
}
